// extracted by mini-css-extract-plugin
export default {"editGroup":"EditGroup_editGroup__IXAta"};